(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("VoiceInputButton", [], factory);
	else if(typeof exports === 'object')
		exports["VoiceInputButton"] = factory();
	else
		root["VoiceInputButton"] = factory();
})(window, function() {
return 